// extracted by mini-css-extract-plugin
export default {"root":"SliderItem_root__8MS9f"};